import { useCallback, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AllBatchesIcon from "../../IconComp/allBatchesIcon";
import RestockBatchesIcon from "../../IconComp/restockBatchesIcon";
import NewBatchesIcon from "../../IconComp/newBatchesIcon";
import NewCircleIcon from "../../IconComp/newCircleIcon";
import RestockCircleIcon from "../../IconComp/restockCircleIcon";
import { SupplierBatchesHeaders } from "../../../utils/constants";
import { ColorPallet } from "../../../utils/colorPallet";
import EditIcon from "../../IconComp/editIcon";
import DeleteIcon from "../../IconComp/deleteIcon";
import AppButton from "../../common/AppButton";
import AddIcon from "../../IconComp/addIcon";
import SaveIcon from "../../IconComp/saveIcon";
import { useAppDispatch } from "../../../app/hooks";
import { getSupplierBatchesData } from "../../../features/supplier/supplierSlice";
import WarningIcon from "../../IconComp/warningIcon";
import EditIcondisable from "../../IconComp/editIconDisable";
import { useRef } from "react";
import { AddSupplierBatch } from "../../../features/batch/batchSlice";
import { useSelector } from "react-redux";
import AppSnackbar from "../../common/AppSnackbar";
import LoadingSpinner from "../../common/Loading";
import AppModal from "../../common/AppModal";
import { DiscardModal } from "../../common/discard-modal";
import WarningIconYellow from "../../IconComp/warningIconYellow";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputIcon from "../../../assets/icon/inputIcon.svg";

const tabStatus = [
  {
    id: 1,
    url: <RestockCircleIcon />,
    title: "Restock Batches",
    batches_length: 4,
  },
  {
    id: 2,
    url: <NewCircleIcon />,
    title: "Newly Added Batches",
    batches_length: 5,
  },
];

interface IProps {
  allSupplier: any;
  shelfData: any;
  supplierId?: any;
}
interface TableRowData {
  id: number;
  batch_no: number;
  name: string;
  total_box: any;
  unit_per_box: any;
  quantity: number;
  shelf_id?: any;
  sell_price: string;
  sell_price_per_box: string;
  cost_price_per_box: string;
  cost_price: string;
  staff_id: string;
  expiry_date: string;
  isNew: boolean;
  alert: boolean;
}

const SupplierBatchModal = ({ allSupplier, shelfData, supplierId }: IProps) => {
  const firstSupplier = allSupplier.find(
    (item: any) => item?.id === supplierId
  );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { bissupBatchLoading } = useSelector((state: any) => state?.batch);
  const dispatch = useAppDispatch();
  const [tableData, setTableData] = useState<any[]>([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const pharmacyId = localStorage?.getItem("pharmacyId");
  const [selectedTab, setSelectedTab] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<any>("");
  const [supplierData, setSupplierData] = useState({
    supplierId: firstSupplier?.id || "",
    supplierName: firstSupplier?.supplier_company_name || "",
  });
  const [editRowIndex, setEditRowIndex] = useState(null);
  const [addRowIndex, setAddRowIndex] = useState(null);
  const [editedData, setEditedData] = useState<Partial<TableRowData>>({});
  const [addedData, setAddedData] = useState<Partial<TableRowData>>({});
  const [updatedRows, setUpdatedRows] = useState<any>([]);
  const originalBatchesRef = useRef<any[]>([]);
  const [discardModal, setDiscardModal] = useState(false);
  const restocklength = tableData?.filter(
    (item: any) => item?.alert === true
  ).length;
  const newlength = tableData?.filter(
    (item: any) => item?.isNew === true
  ).length;
  const tabs = [
    {
      id: 1,
      url: <AllBatchesIcon />,
      title: "All Batches",
      batches_length: tableData.length,
    },
    {
      id: 2,
      url: <RestockBatchesIcon />,
      title: "Restock Batches",
      batches_length: restocklength,
    },
    {
      id: 3,
      url: <NewBatchesIcon />,
      title: "Newly Added",
      batches_length: newlength,
    },
  ];
  const [newBoolenValue, setNewBoolenValue] = useState<any>(false);
  const [totalSellBoxPrice, setTotalSellBoxPrice] = useState(0);
  const [totalCostBoxPrice, setTotalCostBoxPrice] = useState(0);

  useEffect(() => {
    const sellPrice = Number(addedData?.sell_price || 0);
    const unitPerBox = Number(addedData?.unit_per_box || 0);
    const costPrice = Number(addedData?.cost_price || 0);
    setTotalSellBoxPrice(sellPrice * unitPerBox);
    setTotalCostBoxPrice(costPrice * unitPerBox);
  }, [addedData?.sell_price, addedData?.unit_per_box, addedData?.cost_price]);

  const handleDiscardClick = () => {
    setDiscardModal(false);
    getSupplierMedicineBatches();
  };

  const handleSupplierChange = (value: any) => {
    setSupplierData({
      supplierId: value?.id || "",
      supplierName: value?.supplier_company_name || "",
    });
  };
  // Check if the row is in edit mode
  const isEditing = (id: any) => editRowIndex === id;
  const isAdd = (id: any) => addRowIndex === id;

  // Start editing
  const handleEditRow = (id: any, entry: any) => {
    setEditRowIndex(id);
    setEditedData(entry);
  };

  const handleaAddRow = (id: any, entry: any) => {
    setAddRowIndex(id);
    setAddedData(entry);
  };
  // Save edits

  const handleSaveRow = (id: any) => {
    const numericFields = ["batch_no", "total_box", "unit_per_box", "quantity"];

    const convertFieldsToNumbers = (data: any) => {
      const converted = { ...data };
      numericFields.forEach((field) => {
        if (converted[field] !== undefined) {
          converted[field] = Number(converted[field]);
        }
      });
      return converted;
    };

    if (isAdd(id)) {
      const { batch_id, ...filteredData } = addedData as any;

      const newRow = {
        batch_id:
          Date.now().toString() + Math.random().toString(36).substr(2, 9),
        ...convertFieldsToNumbers(filteredData),
        shelf_id: filteredData?.shelf_id ?? null,
        updated_by_admin: filteredData?.staff_id ? false : true,
        sell_price_per_box:
          filteredData?.sell_price * filteredData?.unit_per_box,
        cost_price_per_box:
          filteredData?.cost_price * filteredData?.unit_per_box,
        quantity: filteredData?.total_box * filteredData?.unit_per_box,
        alert: false,
        isNew: true,
        is_edit: false,
        supplier_id: supplierData?.supplierId,
      };

      setTableData((prev) => [...prev, newRow]);
      setUpdatedRows((prev: any[]) => [...prev, newRow]);
      setAddRowIndex(null);
      setAddedData({});
    } else if (isEditing(id)) {
      const rowIndex = tableData.findIndex((row) => row?.batch_id === id);
      if (rowIndex === -1) return;
      const { name, ...filteredData } = editedData as any;
      const updatedRow = {
        ...tableData[rowIndex],
        ...convertFieldsToNumbers(filteredData),
        alert: true,
        isNew: false,
        updated_by_admin: filteredData?.staff_id ? false : true,
        is_edit: true,
        quantity: filteredData?.total_box * filteredData?.unit_per_box,
        sell_price_per_box:
          filteredData?.sell_price * filteredData?.unit_per_box,
        cost_price_per_box:
          filteredData?.cost_price * filteredData?.unit_per_box,
        supplier_id: supplierData?.supplierId,
      };

      const updatedTable = [...tableData];
      updatedTable[rowIndex] = updatedRow;
      setTableData(updatedTable);
      setUpdatedRows((prev: any[]) => {
        const isAlreadyUpdated = prev.some(
          (row) => row.batch_id === updatedRow.batch_id
        );
        return isAlreadyUpdated
          ? prev.map((row) =>
              row.batch_id === updatedRow.batch_id ? updatedRow : row
            )
          : [...prev, updatedRow];
      });

      setEditingIndex(null);
      setEditedData({});
      setEditRowIndex(null);
      setNewBoolenValue(false);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const cleanedRow = updatedRows?.map((row: any) => {
      if (row?.isNew) {
        const { batch_id, ...rest } = row;
        return rest;
      }
      return row;
    });

    dispatch(AddSupplierBatch(cleanedRow)).then((res: any) => {
      if (res?.payload?.success === true) {
        setOpenSnackbar(true);
        getSupplierMedicineBatches();
        setDiscardModal(false);
      }
    });
  };

  const handleInputChange = (
    key: string,
    value: any,
    id: any,
    newBoolenValue?: any
  ) => {
    if (newBoolenValue !== undefined) {
      setNewBoolenValue(newBoolenValue);
    }
    if (key === "shelf_id") {
      const shelfName = shelfData.find((s: any) => s.id === value)?.name || "";
      if (isAdd(id)) {
        setAddedData((prev: any) => ({
          ...prev,
          shelf_id: value,
          shelf: shelfName,
        }));
      }
      return;
    }

    const numericKeys = ["sell_price", "sell_price_per_box"];
    const parsedValue = numericKeys.includes(key) ? Number(value) : value;

    if (isAdd(id)) {
      setAddedData((prev: any) => ({ ...prev, [key]: parsedValue }));
    } else if (isEditing(id)) {
      setEditedData((prev: any) => ({ ...prev, [key]: parsedValue }));
    }
  };

  const handleDeleteRow = (id: any) => {
    const rowToDelete = tableData?.find((row) => row?.batch_id === id);

    if (rowToDelete?.isNew) {
      // remove row completely
      setUpdatedRows((prev: any[]) =>
        prev.filter((row) => row?.batch_id !== id)
      );
      setTableData((prev) => prev.filter((row) => row?.batch_id !== id));
    } else if (rowToDelete?.alert) {
      const originalRow = originalBatchesRef.current.find(
        (row: any) => row?.batch_id === id
      );
      if (originalRow) {
        setTableData((prev) => {
          return prev.map((row: any) => {
            if (row?.batch_id === id) {
              return { ...originalRow, alert: false, is_edit: false };
            }
            return row;
          });
        });
      } else {
        // remove row completely
        setUpdatedRows((prev: any[]) =>
          prev.filter((row) => row?.batch_id !== id)
        );
      }
      setUpdatedRows((prev: any[]) =>
        prev.filter((row) => row?.batch_id !== id)
      );
    }
  };

  const filteredTableData = tableData?.filter((item: any) => {
    if (selectedTab === 2) return item?.alert === true;
    if (selectedTab === 3) return item?.isNew === true;
    return true;
  });

  const getSupplierMedicineBatches = useCallback(async () => {
    const dto = {
      pharmacy_id: pharmacyId,
      supplier_id: supplierData?.supplierId,
    };

    try {
      setIsLoading(true);
      const res = await dispatch(getSupplierBatchesData(dto));
      if (getSupplierBatchesData.rejected.match(res)) {
        setError(res.payload || "Failed to fetch supplier batches");
      } else if (res.payload) {
        const fetchedBatches = res?.payload?.existing_supplier_batch;

        const transformedData = fetchedBatches.map((item: any) => ({
          batch_id: item?.id,
          batch_no: item?.batch_no,
          name: item?.pharmacy_medicine?.name,
          quantity: item?.quantity || 0,
          shelf: item?.shelf?.name || "",
          shelf_id: item?.shelf?.id,
          total_box: item?.total_box || 0,
          unit_per_box: item?.unit_per_box || 0,
          sell_price: item?.sell_price || 0,
          sell_price_per_box:
            (item?.sell_price || 0) * (item?.unit_per_box || 0),
          cost_price: item?.cost_price || 0,
          cost_price_per_box:
            (item?.cost_price || 0) * (item?.unit_per_box || 0),
          pharmacy_id: pharmacyId,
          medicine_id: item?.pharmacy_medicine?.id,
          expiry_date: item.expiry_date || "",
          category_type: item?.super_category,
          staff_id: item?.staff_id || null,
          updated_by_admin: false,
          is_edit: false,
          isNew: false,
          alert: false,
        }));

        setTableData(transformedData);
        originalBatchesRef.current = transformedData;
        setUpdatedRows([]);
        setError("");
      }
    } catch (error) {
      console.error("Error fetching supplier batches:", error);
      setError("Unexpected error occurred");
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, pharmacyId, supplierData?.supplierId]);

  useEffect(() => {
    if (updatedRows?.length > 0) {
      setDiscardModal(true);
    } else {
      getSupplierMedicineBatches();
    }
  }, [getSupplierMedicineBatches, pharmacyId, supplierData?.supplierId]);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
        }}
      >
        {/* Tabs Part */}
        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", sm: "nowrap" },
            alignItems: "stretch",
            border: "1px solid #0055A8",
            borderRadius: "6px",
            overflow: "hidden",
          }}
        >
          {tabs.map((tab, index) => {
            const isSelected = selectedTab === tab.id;
            const isLast = index === tabs.length - 1;
            const nextTabSelected = selectedTab === tabs[index + 1]?.id;

            return (
              <Box
                key={tab?.id}
                sx={{
                  display: "flex",
                  alignItems: "stretch",
                  flexDirection: "row",
                  flexWrap: "nowrap",
                }}
              >
                {/* Tab Box */}
                <Box
                  onClick={() => setSelectedTab(tab?.id)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    backgroundColor: isSelected ? "#0055A8" : "transparent",
                    color: isSelected ? "#FFFFFF" : "#0055A8",
                    padding: { xs: "6px 8px", sm: "8px 12px" },
                    cursor: "pointer",
                    height: "100%",
                    minWidth: "fit-content",
                    border: "none",
                    transition: "background-color 0.3s, color 0.3s",
                  }}
                >
                  {/* Icon */}
                  {!isMobile && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: isSelected ? "#FFFFFF" : "#0055A8",
                        fontSize: { xs: "16px", sm: "18px" },
                      }}
                    >
                      {tab?.url}
                    </Box>
                  )}

                  {/* Title */}
                  <Typography
                    noWrap
                    sx={{
                      color: isSelected ? "#FFFFFF" : "#0055A8",
                      fontWeight: 600,
                      fontSize: { xs: "12px", sm: "14px" },
                      lineHeight: "16px",
                    }}
                  >
                    {tab?.title}
                  </Typography>

                  {/* Badge */}
                  {!isMobile && (
                    <Box
                      sx={{
                        backgroundColor: "#FFFFFF",
                        border: `1px solid #0055A8`,
                        borderRadius: "50%",
                        width: "20px",
                        height: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        ml: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#0055A8",
                          fontWeight: 600,
                          fontSize: "11px",
                          lineHeight: "11px",
                        }}
                      >
                        {tab?.batches_length > 0
                          ? String(tab?.batches_length).padStart(2, "0")
                          : "0"}
                      </Typography>
                    </Box>
                  )}
                </Box>

                {/* Divider */}
                {!isLast && !isSelected && !nextTabSelected && (
                  <Box
                    sx={{
                      height: { xs: "1px", sm: "70%" },
                      width: { xs: "100%", sm: "1px" },
                      backgroundColor: "#0055A8",
                      alignSelf: "center",
                      mx: { xs: 0, sm: "auto" },
                    }}
                  />
                )}
              </Box>
            );
          })}
        </Box>

        {/* Supplier Autocomplete */}

        <Autocomplete
          sx={{ width: "250px" }}
          disablePortal
          id="supplier-autocomplete"
          options={Array.isArray(allSupplier) ? allSupplier : []}
          getOptionLabel={(option) => option?.supplier_company_name || ""}
          value={
            allSupplier.find((s: any) => s.id === supplierData?.supplierId) ||
            null
          }
          onChange={(event, value) => {
            if (value) {
              handleSupplierChange(value);
            } else {
              handleSupplierChange(value);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select Supplier"
              sx={{
                "& .MuiInputBase-input": {
                  padding: "1px 5px !important",
                },
              }}
            />
          )}
        />
      </Box>
      {/** BATHCES STATUS */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "10px",
          mt: "10px",
        }}
      >
        {tabStatus.map((tab, index) => {
          return (
            <>
              <Box>{tab.url}</Box>

              {/* Title */}
              <Typography
                sx={{
                  color: "#000000",
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "22px",
                  fontFamily: theme.typography.fontFamily,
                }}
              >
                {tab.title}
              </Typography>
            </>
          );
        })}
      </Box>
      {/** BATHCES Table */}
      <TableContainer
        sx={{
          maxHeight: {
            xs: 300,
            sm: 400,
            md: 350,
            lg: 600,
            xl: 700,
          },
          "@media (min-width:820px) and (max-width:900px)": {
            maxHeight: 550,
          },
          "@media (min-width:1023px) and (max-width:1050px)": {
            maxHeight: 210,
          },
          "@media (min-width:1200px) and (max-width:1280px)": {
            maxHeight: 400,
          },
          overflowY: "auto",
          overflowX: "auto",
          minWidth: { xs: "100%", sm: "600px" },
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "75vh", // Set height to full viewport height
            }}
          >
            <LoadingSpinner />
          </Box>
        ) : (
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {SupplierBatchesHeaders?.map((item, index) => (
                  <TableCell
                    sx={{
                      borderBottom: `1px solid ${ColorPallet?.borderColor}`,
                      paddingY: "2px !important",
                      paddingLeft: "8px !important",
                      fontSize: isMobile ? "10px" : "14px",
                    }}
                    key={index}
                  >
                    {item.title}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredTableData?.length > 0 ? (
                filteredTableData
                  ?.slice()
                  ?.sort((a, b) => a?.batch_id - b?.batch_id)
                  ?.map((entry: any) => {
                    return (
                      <TableRow
                        sx={{
                          backgroundColor: entry?.alert
                            ? "#FFF7E6"
                            : entry?.isNew
                            ? "#00BB8C14"
                            : "inherit",
                          // borderLeft: entry.alert ? "50px solid #F2C94C" : "none",
                        }}
                      >
                        <TableCell
                          sx={{
                            borderBottom: `1px solid ${ColorPallet?.borderColor}`,
                            paddingY: "2px !important",
                            paddingLeft: "8px !important",
                            fontSize: isMobile ? "10px" : "14px",
                            borderLeft: entry.alert
                              ? "4px solid #F2C94C"
                              : entry?.isNew
                              ? "4px solid #0FB574"
                              : undefined,
                          }}
                        >
                          {isAdd(entry?.batch_id) ? (
                            <TextField
                              variant="outlined"
                              size="small"
                              value={addedData?.batch_no}
                              onChange={(e) =>
                                handleInputChange(
                                  "batch_no",
                                  e.target.value,
                                  entry?.batch_id
                                )
                              }
                              sx={{
                                width: "100px",
                                "& .MuiOutlinedInput-root": {
                                  height: "30px",
                                  margin: "1px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderWidth: "1px",
                                },
                                "& input": {
                                  textAlign: "center",
                                },
                              }}
                            />
                          ) : (
                            entry?.batch_no || "-"
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: `1px solid ${ColorPallet?.borderColor}`,
                            paddingY: "2px !important",
                            paddingLeft: "8px !important",
                            fontSize: isMobile ? "10px" : "14px",
                          }}
                        >
                          {entry?.name || "-"}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: `1px solid ${ColorPallet?.borderColor}`,
                            paddingY: "2px !important",
                            paddingLeft: "8px !important",
                            fontSize: isMobile ? "10px" : "14px",
                          }}
                        >
                          {isEditing(entry?.batch_id) ||
                          isAdd(entry?.batch_id) ? (
                            <TextField
                              variant="outlined"
                              size="small"
                              value={
                                isEditing(entry?.batch_id)
                                  ? editedData?.total_box
                                  : addedData?.total_box
                              }
                              onChange={(e) =>
                                handleInputChange(
                                  "total_box",
                                  e.target.value,
                                  entry?.batch_id
                                )
                              }
                              sx={{
                                width: "100px",
                                "& .MuiOutlinedInput-root": {
                                  height: "30px",
                                  margin: "1px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderWidth: "1px",
                                },
                                "& input": {
                                  textAlign: "center",
                                },
                              }}
                            />
                          ) : (
                            entry?.total_box || "-"
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: `1px solid ${ColorPallet?.borderColor}`,
                            paddingY: "2px !important",
                            paddingLeft: "8px !important",
                            fontSize: isMobile ? "10px" : "14px",
                          }}
                        >
                          {isEditing(entry?.batch_id) ||
                          isAdd(entry?.batch_id) ? (
                            <TextField
                              variant="outlined"
                              size="small"
                              value={
                                isEditing(entry?.batch_id)
                                  ? editedData?.unit_per_box
                                  : addedData?.unit_per_box
                              }
                              onChange={(e) =>
                                handleInputChange(
                                  "unit_per_box",
                                  e.target.value,
                                  entry?.batch_id,
                                  true
                                )
                              }
                              sx={{
                                width: "100px",
                                "& .MuiOutlinedInput-root": {
                                  height: "30px",
                                  margin: "1px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderWidth: "1px",
                                },
                                "& input": {
                                  textAlign: "center",
                                },
                              }}
                            />
                          ) : (
                            entry?.unit_per_box || "-"
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: `1px solid ${ColorPallet?.borderColor}`,
                            paddingY: "2px !important",
                            paddingLeft: "8px !important",
                            fontSize: isMobile ? "10px" : "14px",
                          }}
                        >
                          {isEditing(entry?.batch_id) ||
                          isAdd(entry?.batch_id) ? (
                            <TextField
                              variant="outlined"
                              size="small"
                              value={
                                isEditing(entry?.batch_id)
                                  ? Number(editedData?.total_box || 0) *
                                    Number(editedData?.unit_per_box)
                                  : Number(addedData?.total_box) *
                                    Number(addedData?.unit_per_box)
                              }
                              disabled
                              sx={{
                                width: "100px",
                                "& .MuiOutlinedInput-root": {
                                  height: "30px",
                                  margin: "1px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderWidth: "1px",
                                },
                                "& input": {
                                  textAlign: "center",
                                },
                              }}
                            />
                          ) : (
                            entry?.quantity || "-"
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: `1px solid ${ColorPallet?.borderColor}`,
                            paddingY: "2px !important",
                            paddingLeft: "8px !important",
                            fontSize: isMobile ? "10px" : "14px",
                          }}
                        >
                          {isAdd(entry?.batch_id) ? (
                            <Box
                              sx={{
                                position: "relative",
                                display: "flex",
                                gap: 1.5,
                              }}
                            >
                              {/* Units Price */}
                              <TextField
                                variant="outlined"
                                size="small"
                                type="number"
                                value={addedData?.sell_price}
                                onChange={(e) =>
                                  handleInputChange(
                                    "sell_price",
                                    e.target.value,
                                    entry?.batch_id,
                                    true
                                  )
                                }
                                sx={{
                                  width: "140px",
                                  "& .MuiOutlinedInput-root": {
                                    height: "30px",
                                    margin: "1px",
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderWidth: "1px",
                                  },
                                  "& input": {
                                    textAlign: "center",
                                  },
                                }}
                              />

                              {/* Boxes Price */}
                              <TextField
                                size="small"
                                type="number"
                                variant="outlined"
                                placeholder="Boxes Price"
                                value={
                                  isEditing(entry?.batch_id)
                                    ? newBoolenValue
                                      ? totalSellBoxPrice
                                      : editedData?.sell_price_per_box
                                    : newBoolenValue
                                    ? totalSellBoxPrice
                                    : addedData?.sell_price_per_box
                                }
                                inputProps={{ style: { padding: "10px 12px" } }}
                                disabled
                                sx={{
                                  width: "140px",
                                  "& .MuiOutlinedInput-root": {
                                    height: "30px",
                                    margin: "1px",
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderWidth: "1px",
                                  },
                                  "& input": {
                                    textAlign: "center",
                                  },
                                }}
                              />

                              {/* Half-in-half Icon */}
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "66%",
                                  left: "49.5%",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: 2,
                                  backgroundColor: "#fff",
                                  padding: "0 4px",
                                }}
                              >
                                <img
                                  src={InputIcon}
                                  alt="link icon"
                                  style={{
                                    width: "22px",
                                    height: "22px",
                                  }}
                                />
                              </Box>
                            </Box>
                          ) : (
                            entry?.sell_price || "-"
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: `1px solid ${ColorPallet?.borderColor}`,
                            paddingY: "2px !important",
                            paddingLeft: "8px !important",
                            fontSize: isMobile ? "10px" : "14px",
                          }}
                        >
                          {isAdd(entry?.batch_id) ? (
                            <Box
                              sx={{
                                position: "relative",
                                display: "flex",
                                gap: 1.5,
                              }}
                            >
                              {/* Units Price */}
                              <TextField
                                variant="outlined"
                                size="small"
                                type="number"
                                value={addedData?.cost_price}
                                onChange={(e) =>
                                  handleInputChange(
                                    "cost_price",
                                    e.target.value,
                                    entry?.batch_id,
                                    true
                                  )
                                }
                                sx={{
                                  width: "140px",
                                  "& .MuiOutlinedInput-root": {
                                    height: "30px",
                                    margin: "1px",
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderWidth: "1px",
                                  },
                                  "& input": {
                                    textAlign: "center",
                                  },
                                }}
                              />

                              {/* Boxes Price */}
                              <TextField
                                size="small"
                                type="number"
                                variant="outlined"
                                placeholder="Boxes Price"
                                value={
                                  isEditing(entry?.batch_id)
                                    ? newBoolenValue
                                      ? totalCostBoxPrice
                                      : editedData?.cost_price_per_box
                                    : newBoolenValue
                                    ? totalCostBoxPrice
                                    : addedData?.cost_price_per_box
                                }
                                inputProps={{ style: { padding: "10px 12px" } }}
                                disabled
                                sx={{
                                  width: "140px",
                                  "& .MuiOutlinedInput-root": {
                                    height: "30px",
                                    margin: "1px",
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderWidth: "1px",
                                  },
                                  "& input": {
                                    textAlign: "center",
                                  },
                                }}
                              />

                              {/* Half-in-half Icon */}
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "66%",
                                  left: "49.5%",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: 2,
                                  backgroundColor: "#fff",
                                  padding: "0 4px",
                                }}
                              >
                                <img
                                  src={InputIcon}
                                  alt="link icon"
                                  style={{
                                    width: "22px",
                                    height: "22px",
                                  }}
                                />
                              </Box>
                            </Box>
                          ) : (
                            entry.cost_price || "-"
                          )}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderBottom: `1px solid ${ColorPallet?.borderColor}`,
                            paddingY: "2px !important",
                            paddingLeft: "8px !important",
                            fontSize: isMobile ? "10px" : "14px",
                          }}
                        >
                          {isAdd(entry?.batch_id) ? (
                            <Autocomplete
                              value={shelfData?.find(
                                (s: any) => s.id === addedData?.shelf_id
                              )}
                              onChange={(event, value) => {
                                handleInputChange(
                                  "shelf_id",
                                  value?.id,
                                  entry?.batch_id
                                );
                              }}
                              options={shelfData}
                              getOptionLabel={(option) => option?.name || ""}
                              size="small"
                              disableClearable
                              popupIcon={null}
                              sx={{
                                minWidth: "140px",
                                width: "100px",
                                "& .MuiOutlinedInput-root": {
                                  height: "30px",
                                  margin: "1px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderWidth: "1px",
                                },
                                "& input": {
                                  textAlign: "center",
                                  padding: "2px 5px",
                                  fontSize: "13px",
                                },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Select Shelf"
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      padding: "1px 5px !important",
                                    },
                                  }}
                                />
                              )}
                            />
                          ) : (
                            entry.shelf || "-"
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: `1px solid ${ColorPallet?.borderColor}`,
                            paddingY: "2px !important",
                            paddingLeft: "8px !important",
                            fontSize: isMobile ? "10px" : "14px",
                          }}
                        >
                          {isAdd(entry?.batch_id) ? (
                            <TextField
                              type="date"
                              variant="outlined"
                              size="small"
                              value={(() => {
                                const rawDate = isEditing(entry?.batch_id)
                                  ? editedData?.expiry_date
                                  : addedData?.expiry_date;

                                const date = new Date(rawDate ?? "");
                                if (isNaN(date.getTime())) return "";

                                return date.toISOString().split("T")[0]; // YYYY-MM-DD
                              })()}
                              onChange={(e) =>
                                handleInputChange(
                                  "expiry_date",
                                  e.target.value,
                                  entry?.batch_id
                                )
                              }
                              sx={{
                                width: "120px",
                                "& .MuiOutlinedInput-root": {
                                  height: "30px",
                                  margin: "1px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderWidth: "1px",
                                },
                                "& input": {
                                  textAlign: "center",
                                  padding: "5px 8px",
                                  fontSize: "13px",
                                },
                              }}
                              InputLabelProps={{ shrink: true }}
                            />
                          ) : (
                            <>
                              {entry?.expiry_date &&
                              new Date(entry?.expiry_date) < new Date() ? (
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    color: "red",
                                    gap: "5px",
                                    fontSize: isMobile ? "10px" : "14px",
                                  }}
                                >
                                  <WarningIcon />
                                  {new Date(entry.expiry_date)
                                    .toLocaleDateString("en-GB")
                                    .split("/")
                                    .map((v, i) => (i === 2 ? v.slice(-2) : v))
                                    .join("-")}
                                </span>
                              ) : (
                                new Date(entry.expiry_date)
                                  .toLocaleDateString("en-GB")
                                  .split("/")
                                  .map((v, i) => (i === 2 ? v.slice(-2) : v))
                                  .join("-")
                              )}
                            </>
                          )}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderBottom: `1px solid ${ColorPallet?.borderColor}`,
                            paddingY: "2px !important",
                            paddingLeft: "8px !important",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {isEditing(entry?.batch_id) ||
                            isAdd(entry?.batch_id) ? (
                              <IconButton
                                onClick={() => handleSaveRow(entry?.batch_id)}
                                size="small"
                              >
                                <SaveIcon />
                              </IconButton>
                            ) : (
                              <>
                                <Tooltip title="Edit" arrow>
                                  <IconButton
                                    onClick={() =>
                                      entry?.expiry_date &&
                                      new Date(entry?.expiry_date) < new Date()
                                        ? null
                                        : handleEditRow(entry?.batch_id, entry)
                                    }
                                    size="small"
                                  >
                                    {entry?.expiry_date &&
                                    new Date(entry.expiry_date) < new Date() ? (
                                      <EditIcondisable />
                                    ) : (
                                      <EditIcon />
                                    )}
                                  </IconButton>
                                </Tooltip>

                                {selectedTab === 1 ? (
                                  <Tooltip title="Add" arrow>
                                    <IconButton
                                      onClick={() =>
                                        handleaAddRow(entry?.batch_id, entry)
                                      }
                                      size="small"
                                    >
                                      <AddIcon />
                                    </IconButton>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Delete" arrow>
                                    <IconButton
                                      onClick={() =>
                                        handleDeleteRow(entry?.batch_id)
                                      }
                                      size="small"
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={12}
                    align="center"
                    style={{ height: "11vh" }}
                  >
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </TableContainer>
      <Box
        sx={{
          mt: 2,
        }}
      >
        <AppButton
          variant="contained"
          color="primary"
          type="button"
          onClick={handleSubmit}
          title={
            bissupBatchLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Save"
            )
          }
          sx={{ float: "right" }}
          disabled={bissupBatchLoading || !updatedRows?.length}
        />
      </Box>
      <AppSnackbar
        message="Batch updated/added successfully!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
      <AppModal
        title={
          <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <WarningIconYellow width="21px" height="21px" />
            Reminder
          </span>
        }
        open={discardModal}
        handleClose={() => setDiscardModal(false)}
        fullScreen={false}
        maxWidth="sm"
      >
        <DiscardModal
          handleDiscardClick={handleDiscardClick}
          onSubmit={handleSubmit}
        />
      </AppModal>
    </>
  );
};

export default SupplierBatchModal;
